<template>
    <aside
        class="aside"
        style="grid-column: 1;"
    >
        <nav
            class="aside__nav--sticky"
        >
            <a
                v-for="item in navItems"
                :key="item.id"
                class="aside__item"
                :class="{ active: activeNavItem?.id === item.id }"
                :href="'#' + item.id"
                @click.prevent="scrollTo(item.id)"
            >
                {{ item.title }}
            </a>
            <a
                v-if="hasContextNav"
                class="aside__item aside__item--footer"
                :href="'#contextual-footer'"
                @click.prevent="scrollTo('contextual-footer')"
            >
                {{ t('footer') }}
            </a>
        </nav>
    </aside>
</template>

<script setup lang="ts">
import { computed } from 'vue';
import slugify from 'slugify';

const t = useTranslation('context-nav');

type Props = {
    topItems?: any[];
    sections?: any[];
    types?: string[];
    offset?: number;
    hasContextNav?: boolean;
}
const {
    topItems,
    sections,
    types,
    offset
} = defineProps<Props>();


const defaultTypes = [
    'flexibleSection_accordion_BlockType',
    'flexibleSection_richText_BlockType'
];

const navItems = computed(() => {
    if(!sections) {
        return topItems ?? [];
    }

    const sectionItems = sections.filter((section: any) => {
        return (types ?? defaultTypes).includes(section.__typename);
    }).map((section: any) => ({
        title: section?.title ?? section?.headerText,
        id: slugify(section?.title ?? section?.headerText ?? '' )?.toLowerCase()
    }));

    return [
        ...(topItems ?? []),
        ...sectionItems
    ].filter(i => i.title);
});


const scrollTo = (id: string) => {
    const el = document.getElementById(id);
    if(el) {
        const topOffset = el.getBoundingClientRect().top + window.pageYOffset - (offset ? (offset - 5) : 0);
        window.scrollTo({
            top: topOffset,
            behavior: 'smooth',
        });
    }
};

const activeNavItem = ref(null);

watchEffect(() => {
    if(typeof window === 'undefined') {
        return;
    }

    const scrollHandler = () => {
        const scrollPosition = window.scrollY;
        activeNavItem.value = toValue(navItems).find((item, index) => {
            const nextItem = toValue(navItems)[index + 1];
            const el = document.getElementById(item.id);
            const nextEl = nextItem ? document.getElementById(nextItem.id) : null;
            if (el) {
                // return scrollPosition >= el.offsetTop && scrollPosition < nextEl.offsetTop;
                return (
                    scrollPosition >= el.offsetTop - offset &&
                    (nextEl ? scrollPosition < nextEl.offsetTop - offset : true)
                );
            }
            return false;
        });
    };

    window.addEventListener('scroll', scrollHandler);
    scrollHandler();

    return () => {
        window.removeEventListener('scroll', scrollHandler);
    };
});
</script>

<style lang="less" src="./TheAsideNav.less"></style>
